const normalTextClassName = "font-nunito text-gray-900 font-semibold";
const subNormalTextClassName = "font-nunito text-gray-600 font-normal italic";
const smallTextClassName = "font-nunito text-gray-600 font-normal text-xs";
const pageTitleClassName = "text-2xl font-extrabold";
const cardTitleClassName = "text-xl font-extrabold text-gray-900";
const errorTextClassName = "text-destructive text-[0.8rem] font-medium";
// Red ring shown on an input whose value was rejected (same recipe as FormInput's).
const errorRingClassName =
  "ring-destructive focus-visible:ring-destructive focus-visible:ring-offset-background ring-1 focus-visible:ring-offset-1";

export {
  normalTextClassName,
  subNormalTextClassName,
  smallTextClassName,
  pageTitleClassName,
  cardTitleClassName,
  errorTextClassName,
  errorRingClassName,
};
